import type { HandoffWireItem } from '../lib/api-client';

/** Rótulos PT-BR da prioridade da transferência (A-50: a tela mostrava o código «normal»/«urgent»). */
export const HANDOFF_PRIORITY_LABEL: Record<HandoffWireItem['priority'], string> = {
  low: 'Baixa',
  normal: 'Normal',
  urgent: 'Urgente',
};

export function handoffPriorityLabel(priority: string): string {
  return (HANDOFF_PRIORITY_LABEL as Record<string, string>)[priority] ?? priority;
}

/** Quem transferiu: nome quando o engine manda; nunca o id cru. */
export function handoffInitiatorLabel(h: Pick<HandoffWireItem, 'initiatedByName'>): string {
  return h.initiatedByName !== undefined && h.initiatedByName !== null && h.initiatedByName !== ''
    ? h.initiatedByName
    : 'um colega da equipe';
}
